import { AuthorityTable } from './AuthorityTable';
export default AuthorityTable;
